var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8195C0 9.88124 1.18361 8.47506 3.05449 7.63896C1.29816 6.76485 0.572717 5.43468 0.572717 4.10451C0.572717 1.67221 2.67268 0 5.42172 0C8.43803 0 9.92709 1.86223 9.92709 3.80048C9.92709 5.13064 9.27801 6.53682 7.36895 7.41093C9.31619 8.24703 10.4998 9.6152 10.4998 11.4774C10.4998 14.1758 8.17076 16 5.19263 16C1.98542 16 0 14.0998 0 11.8195ZM8.39985 11.7055C8.39985 9.84323 7.10169 8.93112 4.96355 8.32304C3.13085 8.8171 2.13814 10.0333 2.13814 11.5154C2.06178 13.0736 3.24539 14.4418 5.26899 14.4418C7.17805 14.4798 8.39985 13.3017 8.39985 11.7055ZM2.59631 3.95249C2.59631 5.51069 3.77993 6.34679 5.57444 6.80285C6.91078 6.34679 7.94167 5.39667 7.94167 3.9905C7.94167 2.77435 7.21623 1.48219 5.30717 1.48219C3.55084 1.52019 2.59631 2.66033 2.59631 3.95249Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.309effcde577def597bfb41ce15febbc.svg";
export { ForwardRef as ReactComponent };